import FilterIcon from "Assets/Icons/FilterIcon";
import { CustomDropdownWithSelect } from "Components/CommonComponents/CustomDropdownWithSelect";
import Typography from "Components/CommonComponents/Typography";
import BarTable from "Pages/BranchHealth/Student/BarTable";
import StudentPerformanceGraph from "Pages/BranchHealth/Student/StudentPerformanceGraph";
import { useContext, useEffect, useRef, useState } from "react";
import { Card, Col, Collapse, Row, Spinner } from "reactstrap";
import {
  BASE_URL,
  TESTPERFORMANCE,
} from "utilFunctions/Constants/urlConstants";
import "./studentperformamance.css";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import {
  FilterArrayForTest,
  filterDataForTestType,
  getOverallPerformance,
  getOverAllTableData,
  makeSelectArray,
} from "utilFunctions/helperFunctions/testPerformanceHelpers";
import UpArrowIcon from "Assets/Icons/UpArrowIcon";
import DownArrowIcon from "Assets/Icons/DownArrowIcon";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import { StudentPerformanceContext } from "Context/StudentContext";
import FilterSliderComponent from "Components/FilterSliderComponent/FilterSliderComponent";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import CustomSelect from "Components/CommonComponents/CustomSelect";
const tableHeading = [
  { label: "Test Name", value: "name" },
  { label: "Test Date", value: "time" },
  { label: "Marks Scored", value: "score" },
];
const tableHeading2 = [
  { label: "AIR", value: "allIndiaRank" },
  { label: "Regional Rank", value: "stateRank" },
  { label: "Branch Rank", value: "branchRank" },
  { label: "Batch Rank", value: "batchRank" },
  { label: "Category Rank", value: "categoryRank" },
];
const LIMIT = 20;
export interface filterIFC {
  acadYearState?: {
    label: string;
    value: string;
  };
  testTypeState?: any | null;
  subjectState?: any | null;
}

function StudentPerformancemainHome() {
  const { screen }: any = useWindowSize();
  const { selectedStudent } = useContext<any>(StudentPerformanceContext);
  const filtersStateStatic: any = {
    acadYearState:
      selectedStudent?.academicYears &&
      Array.isArray(selectedStudent?.academicYears)
        ? {
            label:
              selectedStudent?.academicYears[
                selectedStudent?.academicYears.length - 1
              ],
            value:
              selectedStudent?.academicYears[
                selectedStudent?.academicYears.length - 1
              ],
          }
        : selectedStudent?.academicYear,
    testTypeState: null,
    subjectState: null,
  };
  const [filterState, setFilterState] = useState<filterIFC>({
    acadYearState:
      selectedStudent?.academicYears &&
      Array.isArray(selectedStudent?.academicYears)
        ? {
            label:
              selectedStudent?.academicYears[
                selectedStudent?.academicYears.length - 1
              ],
            value:
              selectedStudent?.academicYears[
                selectedStudent?.academicYears.length - 1
              ],
          }
        : selectedStudent?.academicYear,
    testTypeState: null,
    subjectState: null,
  });
  const [showFilter, setShowFilter] = useState<any>(false);
  const [OverallPerformanceArray, setOverallPerformanceArray] = useState<any>(
    []
  );
  const [OverallAvgPerformanceArray, setOverallAvgPerformanceArray] =
    useState<any>([]);
  const [OverallTopperPerformanceArray, setOverallTopperPerformanceArray] =
    useState<any>([]);
  const [isFilterLoading, setisFilterLoading] = useState<any>(false);
  const [isOpenTestPerformance, setIsOpenTestPerformance] = useState<any>(true);
  const [isOpenOlmpPerformance, setIsOpenOlmpPerformance] =
    useState<any>(false);
  const [OverallPerformanceBarLabel, setOverallPerformanceBarLabel] =
    useState<any>([]);
  const [performanceHeadingTable, setPerformanceHeadingTable] =
    useState<any>(tableHeading);
  const [performanceTableData, setperformanceTableData] = useState<any>([]);
  const [OverallPerformanceArrayBU, setOverallPerformanceArrayBU] =
    useState<any>([]);
  // --- olympiad performance ----- //
  const [olmpPerformanceArray, setOlmpPerformanceArray] = useState<any>([]);
  const [olympiadPerformanceBarLabel, setOlympiadPerformanceBarLabel] =
    useState<any>([]);
  const [olympiadHeadingTable, setOlympiadHeadingTable] =
    useState<any>(tableHeading);
  const [olympiadTableData, setOlympiadTableData] = useState<any>([]);
  const [olympiadPerformanceArrayBU, setOlympiadPerformanceArrayBU] =
    useState<any>([]);
  const [subjectsArray, setSubjectsArray] = useState<any>([]);
  const [subjectsArrayBU, setSubjectsArrayBU] = useState<any>([]);
  const [testTypeArray, setTestTypeArray] = useState<any>([]);
  const [isPaneOpen, setisPaneOpen] = useState<boolean>(false);
  const [externalUrl, setExternalUrl] = useState<any>(null);
  const [div1Height, setDiv1Height] = useState<number | "auto">("auto");
  const [hasLoading, setHasLoading] = useState<boolean>(false);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [page, setPage] = useState<number>(0);
  const prevPsid = useRef(null);
  const [filterheadingListing, setfilterheadingListing] = useState([
    {
      name: "Test Type",
      nickName: "testTypeState",
      data: [...testTypeArray],
      singleSelect: false,
      filterSelectedData: [],
    },
    {
      name: "Subject",
      nickName: "subjectState",
      data: [...subjectsArray],
      singleSelect: false,
      filterSelectedData: [],
    },
  ]);
  const [barArray, setBarArray] = useState<any>([
    { label: "Test", value: "name" },
  ]);
  const { makeRequest, loading, responseData } = useGetApi(
    (data: any) => {
      onSuccess(data);
    },
    (error: any) => {
      onerror(error);
    }
  );
  const onSuccess = (response: any) => {
    if (response.data) {
      const classdata =
        response.data?.overallPerformance[
          `${filtersStateStatic?.acadYearState?.label}`
        ].test;
      setHasMore(classdata.length > 0);
      setHasLoading(false);
    }
  };

  const onerror = (err: any) => {
    console.error("Performance data----", err);
    const endYear: any = filtersStateStatic?.acadYearState?.label
      ? filtersStateStatic?.acadYearState?.label.split("-")[1]
      : "";
    if (selectedStudent.stream == "SOE" && endYear >= 25) {
      setHasMore(false);
      setHasLoading(false);
    } else {
      setperformanceTableData([]);
      setPerformanceHeadingTable([]);
      setOverallPerformanceArray([]);
      setOverallPerformanceBarLabel([]);
      setOverallPerformanceArrayBU([]);
      setOlympiadHeadingTable([]);
      setOlympiadTableData([]);
      setOlmpPerformanceArray([]);
      setOlympiadPerformanceBarLabel([]);
      setOlympiadPerformanceArrayBU([]);
    }
  };
  const findMaxSubjectsElement = (data: any) => {
    let maxSubjectsCount = 0;
    let maxSubjectsElement: any = null;

    data.forEach((element: any) => {
      if (element.subjects.length > maxSubjectsCount) {
        maxSubjectsCount = element.subjects.length;
        maxSubjectsElement = element;
      }
    });

    return maxSubjectsElement;
  };

  useEffect(() => {
    if (responseData?.data) {
      console.log(selectedStudent, "selectedStudent54", filterState);
      const successData: any = filterState?.acadYearState?.label
        ? responseData?.data?.overallPerformance[
            `${filterState?.acadYearState?.label}`
          ]
        : responseData?.data?.overallPerformance[
            `${selectedStudent.academicYear}`
          ];
      const allPerformanceArray = successData
        ? getOverallPerformance(successData["test"]) ?? []
        : [];
      if (
        allPerformanceArray &&
        Array.isArray(allPerformanceArray) &&
        allPerformanceArray.length > 0
      ) {
        const allSubjects =
          findMaxSubjectsElement(allPerformanceArray)?.subjects;

        let subjectsObj: any = [];
        if (allSubjects && Array.isArray(allSubjects) && allSubjects.length) {
          subjectsObj = allSubjects.map(function (item: any) {
            return { value: item, label: item };
          });
        }
        setSubjectsArrayBU([...subjectsObj]);
        setPerformanceHeadingTable([
          ...tableHeading,
          ...subjectsObj,
          ...tableHeading2,
        ]);
        const newTableData = getOverAllTableData(successData["test"]);
        const selectedYear: any = filterState?.acadYearState?.value;
        const endYear: any = selectedYear?.split("-")[1];
        if (selectedStudent.stream == "SOE" && endYear >= 25) {
          const newQArray = [...performanceTableData, ...newTableData];
          const filteredArr = newQArray.reduce((acc, current) => {
            const x = acc.find((item: any) => {
              if (current.testId == null) {
                return false;
              } else {
                return item.testId == current.testId;
              }
            });
            if (!x) {
              return acc.concat([current]);
            } else if (
              x.testId == current.testId &&
              current?.score != null &&
              x.score == null
            ) {
              return acc.concat([current]);
            } else {
              return acc;
            }
          }, []);
          const totalDataAfterpagination = [...filteredArr];
          const barlabelArray = totalDataAfterpagination.map(
            (item: any) => item.name
          );
          setperformanceTableData([...filteredArr]);
          setOverallPerformanceArrayBU([...filteredArr]);
          setBarDatafromResponsedata(totalDataAfterpagination);
          setOverallPerformanceBarLabel(barlabelArray);
        } else {
          const totalDataAfterpagination = [...newTableData];
          const barlabelArray = totalDataAfterpagination.map(
            (item: any) => item.name
          );
          setOverallPerformanceBarLabel(barlabelArray);
          setBarDatafromResponsedata(totalDataAfterpagination);

          setperformanceTableData([...newTableData]);
          setOverallPerformanceArrayBU([...newTableData]);
        }

        const subjArray = makeSelectArray(responseData["data"]["subjectList"]);
        setSubjectsArray([...subjArray]);
        let typeArray = [];
        if (selectedStudent.stream == "SOE" && endYear >= 25) {
          typeArray = FilterArrayForTest(
            allPerformanceArray ? allPerformanceArray : [],
            testTypeArray
          );
        } else {
          typeArray = FilterArrayForTest(
            allPerformanceArray ? allPerformanceArray : [],
            []
          );
        }
        setTestTypeArray(typeArray);
        const updateheadingList: any = [
          {
            name: "Test Type",
            nickName: "testTypeState",
            data: typeArray.map((ele: any) => {
              return { ...ele, key: ele.value };
            }),
            singleSelect: false,
            filterSelectedData: [],
          },
          {
            name: "Subject",
            nickName: "subjectState",
            data: [...subjArray].map((ele: any) => {
              return { ...ele, key: ele.value };
            }),
            singleSelect: false,
            filterSelectedData: [],
          },
        ];
        setfilterheadingListing([
          ...JSON.parse(JSON.stringify(updateheadingList)),
        ]);
      } else {
        setperformanceTableData([]);
        setPerformanceHeadingTable([]);
        setOverallPerformanceArray([]);
        setOverallPerformanceBarLabel([]);
        setOverallPerformanceArrayBU([]);
      }

      //------ Olympiad -----//
      const successDataOlmp: any = filterState?.acadYearState?.value
        ? responseData?.data?.overallPerformance["0"]
        : responseData?.data?.overallPerformance["0"];
      const successDataOlmpClassData: any = filterState?.acadYearState?.value
        ? responseData?.data?.overallPerformance[
            `${filterState?.acadYearState?.value}`
          ]
        : responseData?.data?.overallPerformance[
            `${selectedStudent.academicYear}`
          ];

      const successDataOlmpArray = successDataOlmp
        ? getOverallPerformance(successDataOlmp["olmp"]) ?? []
        : [];
      const successDataOlmpClassDataArray = successDataOlmpClassData
        ? getOverallPerformance(successDataOlmpClassData["olmp"]) ?? []
        : [];
      const allOlympiadArray = [
        ...successDataOlmpArray,
        ...successDataOlmpClassDataArray,
      ];

      if (
        allOlympiadArray &&
        Array.isArray(allOlympiadArray) &&
        allOlympiadArray.length > 0
      ) {
        const olympiadSubjects =
          allOlympiadArray && allOlympiadArray[0]?.subjects
            ? allOlympiadArray[0]?.subjects
            : [];
        const subjectsOlmpObj = olympiadSubjects.map(function (item) {
          return { value: item, label: item };
        });
        setOlympiadHeadingTable([
          ...tableHeading,
          ...subjectsOlmpObj,
          ...tableHeading2,
        ]);
        const olmpTableData = successDataOlmp
          ? getOverAllTableData(successDataOlmp["olmp"])
          : [];
        const newOlmpTableClassData = successDataOlmpClassData
          ? getOverAllTableData(successDataOlmpClassData["olmp"])
          : [];
        const newOlmpTableData = [...olmpTableData, ...newOlmpTableClassData];
        setOlympiadTableData(newOlmpTableData);
        const percentolmpArray = newOlmpTableData.map(
          (item: any) => item.percentage
        );
        const barOlmpLabelArray = newOlmpTableData.map(
          (item: any) => item.name
        );
        setOlympiadPerformanceBarLabel(barOlmpLabelArray);
        setOlmpPerformanceArray(percentolmpArray);
        setOlympiadPerformanceArrayBU(newOlmpTableData);
      } else {
        setOlympiadHeadingTable([]);
        setOlympiadTableData([]);
        setOlmpPerformanceArray([]);
        setOlympiadPerformanceBarLabel([]);
        setOlympiadPerformanceArrayBU([]);
      }
    } else {
      clearAllData();
    }
  }, [responseData]);
  const clearAllData = () => {
    setperformanceTableData([]);
    setPerformanceHeadingTable([]);
    setOverallPerformanceArray([]);
    setOverallPerformanceBarLabel([]);
    setOverallPerformanceArrayBU([]);
    setOlympiadHeadingTable([]);
    setOlympiadTableData([]);
    setOlmpPerformanceArray([]);
    setOlympiadPerformanceBarLabel([]);
    setOlympiadPerformanceArrayBU([]);
  };
  function getCurrentAcademicSession() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth(); // 0-indexed: 0 = January, 11 = December

    if (currentMonth >= 3) {
      // April (3) to December
      return `${currentYear}-${String(currentYear + 1).slice(-2)}`;
    } else {
      // January to March
      return `${currentYear - 1}-${String(currentYear).slice(-2)}`;
    }
  }

  function findAcademicSession(sessions: any) {
    const currentSession = getCurrentAcademicSession();
    return sessions.includes(currentSession)
      ? currentSession
      : sessions[sessions.length - 1];
  }

  useEffect(() => {
    if (
      selectedStudent?.psid != null &&
      selectedStudent.psid !== prevPsid.current
    ) {
      const selectedYear =
        selectedStudent &&
        selectedStudent?.academicYears &&
        Array.isArray(selectedStudent?.academicYears)
          ? findAcademicSession(selectedStudent?.academicYears)
          : selectedStudent?.academicYear;

      prevPsid.current = selectedStudent.psid;
      let url =
        BASE_URL +
        TESTPERFORMANCE +
        `psid=${selectedStudent.psid}&academicYear=${selectedYear}&stream=${selectedStudent.stream}`;
      if (selectedStudent.stream == "SOE") {
        url = url + `&offset=0&limit=${LIMIT}`;
      }
      makeRequest(url);
    }
  }, [selectedStudent?.psid]);
  useEffect(() => {
    if (selectedStudent?.academicYear) {
      setFilterState({
        acadYearState:
          selectedStudent?.academicYears &&
          Array.isArray(selectedStudent?.academicYears)
            ? {
                label: findAcademicSession(selectedStudent?.academicYears),
                value: findAcademicSession(selectedStudent?.academicYears),
              }
            : selectedStudent?.academicYear,
        testTypeState: null,
        subjectState: null,
      });
    }
    setBarArray([{ label: "Test", value: "percentage" }]);
  }, [selectedStudent?.psid]);
  const fetchData = (page: any) => {
    const selectedYear: any = filterState?.acadYearState?.value;
    const endYear: any = selectedYear?.split("-")[1];
    if (endYear >= 25) {
      setHasLoading(true);
      const offset = page * LIMIT;
      const url =
        BASE_URL +
        TESTPERFORMANCE +
        `psid=${selectedStudent.psid}&academicYear=${selectedYear}&stream=${selectedStudent.stream}&offset=${offset}&limit=${LIMIT}`;
      makeRequest(url);
    }
  };
  const toggle = () => setIsOpenTestPerformance(!isOpenTestPerformance);
  const toggleOlmp = () => setIsOpenOlmpPerformance(!isOpenOlmpPerformance);
  const toggltePerformanceVisible = () => {
    setShowFilter(!showFilter);
  };
  const clearAllPerformanceVisible = () => {
    setFilterState({
      ...filterState,
      testTypeState: null,
      subjectState: null,
    });
    const barlabelArray = OverallPerformanceArrayBU.map(
      (item: any) => item.name
    );
    setOverallPerformanceBarLabel(barlabelArray);
    setBarDatafromResponsedata(OverallPerformanceArrayBU);
    setperformanceTableData(OverallPerformanceArrayBU);
    setPerformanceHeadingTable([
      ...tableHeading,
      ...subjectsArrayBU,
      ...tableHeading2,
    ]);
    toggltePerformanceVisible();
  };

  const setBarDatafromResponsedata = (data: any) => {
    const percentArray = data.map((item: any) => item.percentage);
    const avgPercentageArray = data.map((item: any) =>
      item?.comparativeMarks?.overall
        ? Math.floor(parseInt(item?.comparativeMarks?.overall?.avgPercentage))
        : null
    );
    const topperPercentageArray = data.map((item: any) =>
      item?.comparativeMarks?.overall
        ? Math.floor(
            parseInt(item?.comparativeMarks?.overall?.topperPercentage)
          )
        : null
    );
    setOverallPerformanceArray(percentArray);
    setOverallAvgPerformanceArray(avgPercentageArray);
    setOverallTopperPerformanceArray(topperPercentageArray);
  };

  const handleAddFilterArrayList = (name: string, val: any) => {
    filtersStateStatic[name] = val;
    setFilterState((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
    if (name == "acadYearState") {
      clearAllData();
      const url =
        BASE_URL +
        TESTPERFORMANCE +
        `psid=${selectedStudent.psid}&academicYear=${val.label}&stream=${selectedStudent.stream}&offset=0&limit=${LIMIT}`;
      makeRequest(url);
      setFilterState((prevState: any) => ({
        ...prevState,
        testTypeState: null,
        subjectState: null,
      }));
    }
    if (name == "testTypeState") {
      if (val && val.length > 0) {
        const filetredArray = filterDataForTestType(
          OverallPerformanceArrayBU,
          val
        );

        const barlabelArray = filetredArray.map((item: any) => item.name);
        setOverallPerformanceBarLabel(barlabelArray);
        setBarDatafromResponsedata(filetredArray);
        const myArrayFiltered = OverallPerformanceArrayBU.filter((el: any) => {
          return val.some((f: any) => {
            return f.value == el.test;
          });
        });
        setperformanceTableData(myArrayFiltered);
      } else {
        const barlabelArray = OverallPerformanceArrayBU.map(
          (item: any) => item.name
        );
        setOverallPerformanceBarLabel(barlabelArray);
        setBarDatafromResponsedata(OverallPerformanceArrayBU);
        setperformanceTableData(OverallPerformanceArrayBU);
      }
    }
    if (name == "subjectState") {
      const myArrayHeadingFiltered = subjectsArrayBU.filter((el: any) => {
        return val.some((f: any) => {
          return f.value == el.value;
        });
      });
      setPerformanceHeadingTable([...tableHeading, ...myArrayHeadingFiltered]);
      setBarArray(makeSubjectbarArray(val));
      console.log("latsubjectState", olympiadPerformanceArrayBU);
    }
  };
  const makeSubjectbarArray = (val: any) => {
    const newArrayForSubjectbar: any = [];
    if (val && val.length > 0) {
      val.map((item: any) => {
        newArrayForSubjectbar.push({
          label: item.label,
          value:
            item.value == "percentage"
              ? item.value
              : item.value + ".percentage",
        });
      });
    } else {
      newArrayForSubjectbar.push({
        label: "Test",
        value: "percentage",
      });
    }
    return newArrayForSubjectbar;
  };
  const applyFilterHandler = () => {
    setisFilterLoading(true);
    const obj: any = {};
    filterheadingListing.forEach((ele: any) => {
      obj[ele.nickName] = ele.singleSelect
        ? ele.filterSelectedData[0]
        : ele.filterSelectedData;
    });
    if (obj.subjectState && obj.subjectState.length) {
      const val = obj.subjectState;
      const myArrayHeadingFiltered = subjectsArrayBU.filter((el: any) => {
        return val.some((f: any) => {
          return f.value == el.value;
        });
      });
      setPerformanceHeadingTable([...tableHeading, ...myArrayHeadingFiltered]);
      setBarArray(makeSubjectbarArray(val));
    }
    const val = obj.testTypeState;
    if (val && val.length > 0) {
      const filetredArray = filterDataForTestType(
        OverallPerformanceArrayBU,
        val
      );
      const percentArray = filetredArray.map((item: any) => item.percentage);
      const barlabelArray = filetredArray.map((item: any) => item.name);
      setOverallPerformanceBarLabel(barlabelArray);
      setOverallPerformanceArray(percentArray);

      const myArrayFiltered = OverallPerformanceArrayBU.filter((el: any) => {
        return val.some((f: any) => {
          return f.value == el.test;
        });
      });
      setperformanceTableData(myArrayFiltered);
    }
    setFilterState(obj);
    setisFilterLoading(false);
  };
  useEffect(() => {
    if (externalUrl && externalUrl != null) {
      const newWindow = window.open("", "_blank", "fullscreen=yes");
      if (newWindow) {
        newWindow.document.write(`
          <!DOCTYPE html>
          <html lang="en">
            <head>
              <meta charset="UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
              <title>Subject-Test Analysis</title>
            </head>
            <body style="margin: 0;">
              <iframe src="${externalUrl}" style="width: 100%; height: 100vh; border: none;"></iframe>
            </body>
          </html>
        `);
        newWindow.document.close();
      }
    }
  }, [externalUrl]);
  console.log(
    OverallPerformanceArray,
    OverallPerformanceBarLabel,
    "OverallPerformanceArray"
  );
  return (
    <div className="mt-3">
      {["xs", "sm", "md"].includes(screen) && (
        <FilterSliderComponent
          width={"100%"}
          isPaneOpen={isPaneOpen}
          setisPaneOpen={setisPaneOpen}
          hideHeader={true}
          filterheadingListing={filterheadingListing}
          setfilterheadingListing={setfilterheadingListing}
          applyFilterHandler={applyFilterHandler}
        ></FilterSliderComponent>
      )}
      <Card style={{ padding: "16px", marginBottom: "16px" }}>
        <>
          <div className="w-100 d-flex flex-row justify-content-between barGraphHeading">
            <div className="d-flex w-80 flex-row align-items-center gap-2">
              <Typography variant="h6" color="black">
                Test Performance
              </Typography>
              <div className="d-flex flex-row align-items-center gap-2">
                <div className="d-flex flex-row align-items-center gap-1">
                  <div className="legend-style-for-graph avg-legend"></div>
                  <Typography variant="forminfo" color="black">
                    {" "}
                    Average
                  </Typography>
                </div>
                <div className="d-flex flex-row align-items-center gap-1">
                  <div className="legend-style-for-graph student-legend"></div>
                  <Typography variant="forminfo" color="black">
                    {" "}
                    {selectedStudent?.name}
                  </Typography>
                </div>
                <div className="d-flex flex-row align-items-center gap-1">
                  <div className="legend-style-for-graph topper-legend"></div>
                  <Typography variant="forminfo" color="black">
                    {" "}
                    Topper
                  </Typography>
                </div>
              </div>
            </div>

            {showFilter ? (
              <>
                <div className="d-flex flex-row filtersPerformanceDiv justify-content-end">
                  {/* {selectedStudent?.acadToClassMap &&
                  Array.isArray(selectedStudent?.acadToClassMap) &&
                  selectedStudent?.acadToClassMap.length ? ( */}
                  <div className="mr-3">
                    <CustomSelect
                      isSelected={
                        filterState.acadYearState != null ? true : false
                      }
                      width={"120px"}
                      placeholder="Acad Year"
                      isInPerformance={true}
                      options={selectedStudent?.acadToClassMap}
                      isSearchable={false}
                      menuPlacement="bottom"
                      isClearable={false}
                      name={"customname"}
                      menuShouldScrollIntoView={true}
                      closeMenuOnSelect={true}
                      onChange={(selected: any) => {
                        handleAddFilterArrayList("acadYearState", selected);
                      }}
                      value={filterState.acadYearState}
                    />
                  </div>
                  {/* ) : null} */}
                  <div>
                    <CustomDropdownWithSelect
                      placeholderLabel="Test Type"
                      placeholder=""
                      width={240}
                      allowSelectAll={true}
                      options={[...testTypeArray]}
                      isSearchableDrop={true}
                      isDropdownSelect={true}
                      isMulti={true}
                      isSearchable={true}
                      isClearable={false}
                      isDisabled={false}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      menuPlacement="bottom"
                      menuShouldScrollIntoView={true}
                      onChange={(selected: any) => {
                        handleAddFilterArrayList("testTypeState", selected);
                      }}
                      value={filterState.testTypeState}
                      data-minimum-results-for-search="Infinity"
                    />
                  </div>
                  <div className="betweenFilter">
                    <CustomDropdownWithSelect
                      placeholderLabel="Subject"
                      placeholder=""
                      width={240}
                      allowSelectAll={true}
                      options={[...subjectsArray]}
                      isMulti={true}
                      isSearchableDrop={true}
                      isDropdownSelect={true}
                      isSearchable={true}
                      isClearable={false}
                      isDisabled={false}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      menuPlacement="bottom"
                      menuShouldScrollIntoView={true}
                      onChange={(selected: any) => {
                        handleAddFilterArrayList("subjectState", selected);
                      }}
                      value={filterState.subjectState}
                      data-minimum-results-for-search="Infinity"
                    />
                  </div>
                  <div
                    className="d-flex align-items-center ml-3"
                    onClick={() => clearAllPerformanceVisible()}
                  >
                    <span className="filterSpan">Reset All</span>
                  </div>
                  <div className="cursorHoverCSS" onClick={toggle}>
                    {isOpenTestPerformance ? (
                      <UpArrowIcon />
                    ) : (
                      <DownArrowIcon />
                    )}
                  </div>
                </div>
              </>
            ) : (
              <div className="d-flex flex-row">
                <div
                  className="d-flex align-items-center mt-n2"
                  onClick={() => {
                    if (["xs", "sm", "md"].includes(screen)) {
                      setisPaneOpen(!isPaneOpen);
                    } else {
                      toggltePerformanceVisible();
                    }
                  }}
                >
                  <span className="filterSpan">Filter</span>
                  <FilterIcon className="cursor-pointer" />
                </div>
                <div className="cursorHoverCSS" onClick={toggle}>
                  {isOpenTestPerformance ? <UpArrowIcon /> : <DownArrowIcon />}
                </div>
              </div>
            )}
          </div>

          {loading && page == 0 ? (
            <Spinner></Spinner>
          ) : (
            <Collapse isOpen={isOpenTestPerformance}>
              {performanceTableData && performanceTableData.length === 0 ? (
                <div className="mt-4 mb-8">
                  <NoResultFoundSearch
                    primaryMessage="Performance data not available"
                    secondaryMessage={
                      "No test data is available for the student, either because no tests have been taken or the performance data is awaiting synchronization in the system."
                    }
                  >
                    <NoDataFoundIcon />
                  </NoResultFoundSearch>
                </div>
              ) : (
                <Row className="">
                  <Col
                    sm="12"
                    md="12"
                    lg="12"
                    className="d-flex flex-row justify-content-start mt-2"
                  >
                    <StudentPerformanceGraph
                      graphLoading={loading}
                      mode="testPerformance"
                      barArray={barArray}
                      tableHeading={performanceHeadingTable}
                      filterState={filterState}
                      OverallPerformanceArray={OverallPerformanceArray}
                      div1Height={div1Height}
                    />
                    <BarTable
                      isOlympiad={false}
                      hasMore={hasMore}
                      page={page}
                      hasLoading={hasLoading}
                      graphLoading={loading}
                      setPage={setPage}
                      fetchData={fetchData}
                      tableData={performanceTableData}
                      tableHeading={performanceHeadingTable}
                      tableloading={false}
                      barArray={barArray}
                      filterState={filterState}
                      barData={OverallPerformanceArray}
                      avgData={OverallAvgPerformanceArray}
                      topperData={OverallTopperPerformanceArray}
                      barLabel={OverallPerformanceBarLabel}
                      externalUrl={externalUrl}
                      setExternalUrl={setExternalUrl}
                      setDiv1Height={setDiv1Height}
                      studentPSID={selectedStudent?.psid}
                      studentsStream={selectedStudent.stream}
                    />
                  </Col>
                </Row>
              )}
            </Collapse>
          )}
        </>
      </Card>
      <Card style={{ padding: "16px" }}>
        <>
          <div className="w-100 d-flex flex-row justify-content-between barGraphHeading">
            <Typography variant="h6" color="black">
              Olympiad Performance
            </Typography>

            <div className="cursorHoverCSS" onClick={toggleOlmp}>
              {isOpenOlmpPerformance ? <UpArrowIcon /> : <DownArrowIcon />}
            </div>
          </div>

          {loading && page == 0 ? (
            <Spinner></Spinner>
          ) : (
            <Collapse isOpen={isOpenOlmpPerformance}>
              {olympiadTableData && olympiadTableData.length === 0 ? (
                <div className="mt-4 mb-8">
                  <NoResultFoundSearch
                    primaryMessage="Performance data not available"
                    secondaryMessage={
                      "Performance is being compiled and will be displayed soon"
                    }
                  >
                    <NoDataFoundIcon />
                  </NoResultFoundSearch>
                </div>
              ) : (
                <Row className="">
                  <Col
                    sm="12"
                    md="12"
                    lg="12"
                    className="d-flex flex-row justify-content-start mt-2"
                  >
                    <StudentPerformanceGraph
                      graphLoading={loading}
                      mode="testPerformance"
                      barArray={barArray}
                      tableHeading={olympiadHeadingTable}
                      filterState={filterState}
                      OverallPerformanceArray={olmpPerformanceArray}
                      div1Height={div1Height}
                    />
                    <BarTable
                      isOlympiad={true}
                      hasMore={hasMore}
                      page={page}
                      hasLoading={hasLoading}
                      graphLoading={loading}
                      setPage={setPage}
                      fetchData={fetchData}
                      isFilterLoading={isFilterLoading}
                      tableData={olympiadTableData}
                      tableHeading={olympiadHeadingTable}
                      tableloading={false}
                      barArray={barArray}
                      filterState={filterState}
                      barData={olmpPerformanceArray}
                      barLabel={olympiadPerformanceBarLabel}
                      setDiv1Height={setDiv1Height}
                      studentPSID={selectedStudent?.psid}
                      studentsStream={selectedStudent.stream}
                    />
                  </Col>
                </Row>
              )}
            </Collapse>
          )}
        </>
      </Card>
    </div>
  );
}

export default StudentPerformancemainHome;
